import { ReactNode } from 'react';
import { Flex } from 'antd';
import styles from '../styles.module.css';

export const TabContent = ({ children, noScroll }: { children: ReactNode; noScroll?: boolean }) => {
  const classNames = [styles.tabContent];
  if (noScroll) {
    classNames.push(styles.noScroll, 'enso-ui-tab-no-scroll');
  } else {
    classNames.push(styles.scroll);
  }

  return (
    <Flex vertical gap={24} className={classNames.join(' ')}>
      {children}
    </Flex>
  );
};
